import { View, Text, TouchableOpacity } from "react-native";
import React from "react";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";

import { Ionicons } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";

import GlobalStyles from "../../Resources/Styles";
import { useScreenDimensions, useDevice } from "../_layout";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../utils/numberUtils";

const BodyweightCalendarButton = ({ bodyweight }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();

  return (
    <View style={[GlobalStyles.touchableRow, {}]}>
      <View
        style={[
          GlobalStyles.calendarRow,
          {
            flex: 1,
            flexWrap: "wrap",
            alignItems: "flex-start",
          },
        ]}
      >
        <View style={{ alignItems: "flex-start", flex: 1 }}>
          <View style={GlobalStyles.HStack}>
            <Text
              style={[
                Fonts.bold16,
                {
                  paddingBottom: 8,
                  flexShrink: 1,
                },
              ]}
            >
              {t("bodyweight-string")}
            </Text>
          </View>
          <View
            style={[
              GlobalStyles.HStack,
              {
                flexWrap: "wrap",
                flex: 1,
                rowGap: 0,
              },
            ]}
          >
            <View style={[GlobalStyles.HStack, { flexShrink: 1 }]}>
              <Ionicons
                name="person"
                size={13}
                color={Colors.bodyweightColor}
                style={GlobalStyles.rowIcon}
              />
              <Text style={{ ...GlobalStyles.rowSubText, marginRight: 0 }}>
                {t("todayBodyweight-string", {
                  bodyweight: formatNumber(bodyweight.bodyweight),
                })}
                {bodyweight.client.bodyweightUnit ? "lbs" : "kg"}
              </Text>
            </View>
          </View>
        </View>
        <View style={GlobalStyles.Spacer} />
      </View>
    </View>
  );
};

export default BodyweightCalendarButton;
